<div class="animated fadeIn">
    <div class="c-1 bg-ghost d-flex align-items-center justify-content-between p-3">
        <h3 class="m-0 cl-blue fs-18 fw-bold">Desglose de gastos</h3>
        <img src="assets/icons/arrow_icon_up.svg" alt="" class="me-4 cr-pointer" (click)="hideInfo()">
    </div>
    <div class="c-2 bg-white p-2 d-flex align-items-center justify-content-between my-1">
        <h3 class="m-0 cl-grey fs-14 ms-2">Monto disponible:</h3>
        <h3 class="m-0 fs-14 cl-grey me-4">{{ calculateAmount | currency: '$' }}</h3>
    </div>
    <div class="c-3 bg-ghost p-2 d-flex align-items-center justify-content-between my-1">
        <h3 class="m-0 cl-grey fs-14 ms-2">Comisión por fondeo:</h3>
        <h3 class="m-0 fs-14 cl-grey me-4">{{dev?.commissionWithOutIVA | percent }} - {{comisionTotal | currency: '$'}}</h3>
    </div>
    <div class="c-4 bg-white p-2 d-flex align-items-center justify-content-between my-1">
        <h3 class="m-0 cl-grey fs-14 ms-2">IVA:</h3>
        <h3 class="m-0 fs-14 cl-grey me-4">{{ 16 }} % - {{ivaTotalF | currency: '$' }}</h3>
    </div>
    <div class="c-5 bg-ghost p-2 d-flex align-items-center justify-content-between my-1 mb-0">
        <h3 class="m-0 cl-grey fs-14 ms-2">Monto neto:</h3>
        <h3 class="m-0 fs-14 cl-grey me-4 fw-bold">{{ amountNetFinal | currency: '$' }}</h3>
    </div>
    <div class="c-6 d-flex align-items-center justify-content-between">
        <div>
            <h3 class="text-white fs-14 fw-light m-0">¿Deseas confirmar la operación?</h3>
        </div>
        <div>
            <button class="btn-white btn ms-3"> Cancelar </button>
            <button class="btn-blue btn ms-3"> Aceptar </button>
        </div>
    </div>
</div>